/* eslint-disable prettier/prettier */
import React from 'react'
import { Image } from 'semantic-ui-react'
import SchoolIcon from 'components/icons/SchoolIcon'
import { prussian, mercury } from 'constants/inlineStyles'
import { pageImageUrl } from '../../../../../../../shared/utils/URLs'

let styles = {}

const FlyerImages = ({ flyer, pages, flyerTitle, senderEmail, category }) => {  
  const sellerIsSchool = category === 'School'

  return (
    <div style={styles.flyerImageListContainer}>
      {pages.map(page => (
        <div key={page.page_number} style={styles.flyerImageListItem}>
          <Image
            src={pageImageUrl(flyer, page.page_number)}
            className="flyerImage"
            style={styles.flyerImage}
            alt={`Image of a flyer titled ${flyerTitle}`}
            aria-describedby={`flyer-Description-Details-${page.page_number}`}
          />
          <span
            id={`flyer-Description-Details-${page.page_number}`}
            style={styles.flyerDescription}
          >
            Text Found On Flyer -
            {page.ocr_text || 'No Text Available'} Need more information on this
            flyer? You can email the person who submitted the flyer at{' '}
            {senderEmail} to learn more.
          </span>
          <div style={styles.flyerImageMetaWrapper}>
            <span style={styles.pageNumberWrapper}>
              Page {page.page_number} of {pages.length}
            </span>
            {sellerIsSchool && (
              <span style={styles.metaSchoolWrapper}>
                <SchoolIcon style={styles.metaSchoolIcon} />School Flyer
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}

styles = {
  flyerImageListContainer: {
    paddingBottom: '1rem',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    msFlexNegative: 0,
    minHeight: '1px' // IE needs this,
  },
  flyerImageListItem: {
    maxWidth: '100%',
    marginBottom: '40px'
  },
  flyerImage: {
    border: `4px solid ${mercury}`
  },
  flyerDescription: {
    position: 'absolute',
    left: '-10000px',
    top: 'auto',
    width: '1px',
    height: '1px',
    overflow: 'hidden'
  },
  flyerImageMetaWrapper: {
    display: 'flex',
    flexFlow: 'row-reverse nowrap',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    color: prussian,
    fontWeight: 'bold',
    marginTop: '10px'
  },
  metaSchoolWrapper: {
    opacity: '.6'
  },
  metaSchoolIcon: {
    position: 'relative',
    top: '5px',
    marginRight: '5px'
  },
  currentPageNumber: {
    fontWeight: 700,
    opacity: 1
  }
}
export default FlyerImages



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerDetail/components/FlyerDetailBody/components/ImageBody.js